import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-search-suggestion',
  templateUrl: './search-suggestion.component.html',
  styleUrls: ['./search-suggestion.component.css']
})
export class SearchSuggestionComponent implements OnInit {

  @Output() openSearchBox: EventEmitter<any> = new EventEmitter<any>();
  @Output() searchData: EventEmitter<any> = new EventEmitter<any>();
  @Output() focuseOnOff: EventEmitter<any> = new EventEmitter<any>();
  @Input() suggestionData:any;
  @Input() isPrompt:any;
  @Input() AllData:any;
isSearchActive: boolean = false; // Controls search input visibility
searchTerm: string = ''; // Tracks the input value
suggestions: string[] = [
  'Apple',
  'Banana',
  'Cherry',
  'Date',
  'Elderberry',
  'Fig',
  'Grape',
  'Honeydew',
]; // Sample suggestion data
filteredSuggestions: string[] = []; // Stores filtered suggestions
private typingTimer: any;
constructor(private elementRef: ElementRef,private sanitizer: DomSanitizer) {}

ngOnInit(): void {
  
}

// Toggle search input expansion
toggleSearch(): void {
  this.isSearchActive = !this.isSearchActive;
  if (!this.isSearchActive) {
    this.searchTerm = ''; // Clear search term
    this.filteredSuggestions = []; // Clear suggestions
  }
}

// Show suggestions dynamically
// showSuggestions(): void {
//   const value = this.searchTerm.toLowerCase().trim();
//   if (value) {
//     this.filteredSuggestions = this.suggestionData.filter((item) =>
//       item.Stmt.toLowerCase().includes(value)
//     );
//   } else {
//     this.filteredSuggestions = [];
//   }

//   this.onSearchInput()
// }

showSuggestions(): void {
  const value = this.searchTerm.toLowerCase().trim();
  if (value) {
    this.filteredSuggestions = this.suggestionData
      .filter((item) =>
        item.Stmt.toLowerCase().startsWith(value)
      )
      .map((item) => {
        const original = item.Stmt;
        const matchLength = value.length;
        const highlighted = this.sanitizer.bypassSecurityTrustHtml(`<span style="background-color: #d1d8e0; color: #212529; font-weight: 500; padding: 2px 0px; border-radius: 2px;">${original.slice(0, matchLength)}</span>${original.slice(matchLength)}`);
        return { ...item, highlightedStmt: highlighted };
      });
  } else {
    this.filteredSuggestions = [];
  }

  this.onSearchInput();
}


// Select a suggestion
selectSuggestion(value: string): void {
  this.searchTerm = value; // Update search term
  this.filteredSuggestions = []; // Clear suggestions
  this.onSearchInput()
}

// Clear the search input
clearSearch(): void {
  this.searchTerm = ''; // Clear input value
  this.filteredSuggestions = []; // Clear suggestions
  this.onSearchInput()
}

couseSearch(){
  // this.clearSearch()
  this.isSearchActive = false;
}

// Detect clicks outside the search box
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  const clickedInside = this.elementRef.nativeElement.contains(event.target);
  if (!clickedInside) {
    this.isSearchActive = false; // Close the search box
    this.openSearchBox.emit(this.isSearchActive);
    this.filteredSuggestions = [];
  }else{
    this.openSearchBox.emit(this.isSearchActive)
  }
}

onSearchInput() {
  clearTimeout(this.typingTimer); // Clear the previous timer
  this.typingTimer = setTimeout(() => {
    if(this.isPrompt == 'N'){
      const searchData = this.AllData.filter((data) => JSON.stringify(data).toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);
      this.searchData.emit(searchData)
        if (searchData.length == 0) {
            setTimeout(() => {
              this.searchTerm = ''
        }, 5000);
      }
    }else{
        this.searchData.emit(this.searchTerm);
       const searchData = this.AllData.filter((data) => JSON.stringify(data).toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);
       if (searchData.length == 0) {
            setTimeout(() => {
              this.searchTerm = ''
        }, 5000);
    }
  }
    // this.searchApi(this.searchTerm);
  }, 1000); // Waits 1 second before calling the API
}

removeHtmlTags(input) {
  return input.replace(/<[^>]*>/g, '');
}
// Cleanup: Remove event listener on destroy
ngOnDestroy(): void {
  // Angular automatically handles HostListeners, no need to explicitly remove it.
}
onFocus(){
  console.log("focuse on", this.isSearchActive)
  // this.focuseOnOff.emit(true)
}
}


// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/search-suggestion/search-suggestion.component.ts